// // Incubators Data - Updated with IN-Space addition
// const incubators = [
//   { id: 0, name: "IN-Space", image: "/assets/incubator/inspace.png" },
//   { id: 1, name: "Maker Village", image: "/assets/incubator/Makervillage.webp" },
//   { id: 2, name: "KAU RABI", image: "/assets/incubator/rabi.webp" },
//   { id: 3, name: "KSUM", image: "/assets/incubator/ksum.webp" },
//   { id: 4, name: "Digital University Kerala", image: "/assets/incubator/duk.webp" },
//   { id: 5, name: "NAARM", image: "/assets/incubator/naarm.webp" },
//   { id: 6, name: "ICAR", image: "/assets/incubator/ikar.webp" },
// ];

// // Advisors Data
// const advisors = [
//   { name: 'Dr Anilakumar', designation: 'Amala Cancer Care Institute', image: '/assets/team/Dr-Anilakumar.webp' },
//   { name: 'Dr Snany Surendran', designation: 'MVR Cancer Care Institute', image: '/assets/team/Snany.webp' },
//   { name: 'Dr Reshmi', designation: 'Seed Farm Director, Alathur, Kerala', image: '/assets/team/Reshmi.webp' },
// ];

// // Team Data
// const team = [
//   { name: 'Pradeep Kumar P', designation: 'Chief Executive Officer', image: '/assets/team/pradeep.webp' },
//   { name: 'Nidheesh V', designation: 'Chief Technical Officer', image: '/assets/team/nidheesh.webp' },
//   { name: 'S Athuldas', designation: 'Chief Growth Officer', image: '/assets/team/athul.webp' },
//   { name: 'Deepthi A', designation: 'Chief Operations Officer', image: '/assets/team/deepthi.webp' },
//   { name: 'Arun Babu V', designation: 'Chief Application Developer', image: '/assets/team/arun.webp' },
//   { name: 'Prajith A K', designation: 'Chief Creative Head', image: '/assets/team/prajith1.webp' },
//   { name: 'Pradeep R', designation: 'Manufacturing Coordinator', image: '/assets/team/pradeep1.webp' },
// ];

// const SectionTitle = ({ children, subtitle }) => (
//   <div className="mb-12 text-center">
//     <h2 className="text-4xl md:text-5xl font-bold mb-2">
//       <span
//         className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent"
//       >
//         {children}
//       </span>
//     </h2>
//     {subtitle && (
//       <p className="text-gray-400 text-sm mt-2">{subtitle}</p>
//     )}
//     {/* Simple underline */}
//     <div className="mt-4 flex justify-center">
//       <div className="w-16 h-0.5 bg-gradient-to-r from-blue-400 to-cyan-400"></div>
//     </div>
//   </div>
// );

// const IncubatorCard = ({ incubator }) => (
//   <div className="flex flex-col items-center group cursor-pointer">
//     <div 
//       className="w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden border-3 border-gray-600 hover:border-cyan-400 transition-all duration-300 group-hover:scale-105 mb-4"
//       style={{
//         backgroundImage: `url(${incubator.image})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//       }}
//     >
//     </div>
//     <h3 className="text-white text-lg font-semibold text-center group-hover:text-cyan-400 transition-colors duration-300">
//       {incubator.name}
//     </h3>
//   </div>
// );

// const PersonCard = ({ person }) => (
//   <div className="flex flex-col items-center group cursor-pointer">
//     <div 
//       className="w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden border-3 border-gray-600 hover:border-cyan-400 transition-all duration-300 group-hover:scale-105 mb-4"
//       style={{
//         backgroundImage: `url(${person.image})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//       }}
//     >
//     </div>
//     <h3 className="text-white text-lg font-semibold text-center mb-1 group-hover:text-cyan-400 transition-colors duration-300">
//       {person.name}
//     </h3>
//     <p className="text-gray-400 text-sm text-center leading-tight">
//       {person.designation}
//     </p>
//   </div>
// );

// const Enablers = () => {
//   return (
//     <div className="min-h-screen">
//       <div className="px-6 py-16 max-w-7xl mx-auto">
        
//         {/* Incubators Section */}
//         <section className="mb-20">
//           <SectionTitle subtitle="Caax and Krishisat">
//             Enablers
//           </SectionTitle>
          
//           {/* First row - 6 items */}
//           <div className="grid grid-cols-3 md:grid-cols-6 gap-8 md:gap-12 justify-items-center mb-8">
//             {incubators.slice(0, 6).map((incubator) => (
//               <IncubatorCard key={incubator.id} incubator={incubator} />
//             ))}
//           </div>
          
//           {/* Second row - 1 item centered */}
//           {incubators.length > 6 && (
//             <div className="flex justify-center">
//               <IncubatorCard incubator={incubators[6]} />
//             </div>
//           )}
//         </section>

//         {/* Advisors Section */}
//         <section className="mb-20">
//           <SectionTitle>
//             Meet Our Advisors
//           </SectionTitle>
          
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-12 justify-items-center max-w-4xl mx-auto">
//             {advisors.map((advisor, index) => (
//               <PersonCard key={index} person={advisor} />
//             ))}
//           </div>
//         </section>

//         {/* Team Section */}
//         <section>
//           <SectionTitle>
//             Meet Our Team
//           </SectionTitle>
          
//           {/* First row - 4 team members */}
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 justify-items-center mb-12">
//             {team.slice(0, 4).map((member, index) => (
//               <PersonCard key={index} person={member} />
//             ))}
//           </div>
          
//           {/* Second row - 4 team members */}
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 justify-items-center">
//             {team.slice(4, 8).map((member, index) => (
//               <PersonCard key={index + 4} person={member} />
//             ))}
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default Enablers;
/**
 * Enablers.jsx
 * Redesigned to match the site vibe:
 *  - Playfair Display + Syne fonts
 *  - Brand gradient #1263AF → #06CCBC
 *  - Ghost bg text, dot-grid, accent glows
 *  - Scroll-reveal stagger animations
 *  - Marquee dividers between sections
 *  - Editorial section headers
 */

import { useEffect, useRef, useState } from "react";

// ─── Data ─────────────────────────────────────────────────────────────────────
const incubators = [
  { id: 0, name: "IN-Space",               image: "/assets/incubator/inspace.png"      },
  { id: 1, name: "Maker Village",           image: "/assets/incubator/Makervillage.webp"},
  { id: 2, name: "KAU RABI",               image: "/assets/incubator/rabi.webp"        },
  { id: 3, name: "KSUM",                   image: "/assets/incubator/ksum.webp"        },
  { id: 4, name: "Digital University Kerala", image: "/assets/incubator/duk.webp"      },
  { id: 5, name: "NAARM",                  image: "/assets/incubator/naarm.webp"       },
  { id: 6, name: "ICAR",                   image: "/assets/incubator/ikar.webp"        },
];

const advisors = [
  { name: "Dr Anilakumar",    designation: "Amala Cancer Care Institute",        image: "/assets/team/Dr-Anilakumar.webp" },
  { name: "Dr Snany Surendran", designation: "MVR Cancer Care Institute",        image: "/assets/team/Snany.webp"         },
  { name: "Dr Reshmi",        designation: "Seed Farm Director, Alathur, Kerala", image: "/assets/team/Reshmi.webp"       },
];

const team = [
  { name: "Pradeep Kumar P", designation: "Chief Executive Officer",     image: "/assets/team/pradeep.webp"  },
  { name: "Nidheesh V",      designation: "Chief Technical Officer",     image: "/assets/team/nidheesh.webp" },
  { name: "S Athuldas",      designation: "Chief Growth Officer",        image: "/assets/team/athul.webp"    },
  { name: "Deepthi A",       designation: "Chief Operations Officer",    image: "/assets/team/deepthi.webp"  },
  { name: "Arun Babu V",     designation: "Chief Application Developer", image: "/assets/team/arun.webp"     },
  { name: "Prajith A K",     designation: "Chief Creative Head",         image: "/assets/team/prajith1.webp" },
  { name: "Pradeep R",       designation: "Manufacturing Coordinator",   image: "/assets/team/pradeep1.webp" },
];

// ─── Scroll-reveal hook ────────────────────────────────────────────────────────
const useReveal = (threshold = 0.12) => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
};

// ─── Marquee ──────────────────────────────────────────────────────────────────
const Marquee = ({ words, accent = "#06CCBC" }) => (
  <div className="overflow-hidden border-y py-3" style={{ borderColor: "rgba(255,255,255,.05)" }}>
    <div style={{ display: "flex", width: "max-content", animation: "enMarquee 28s linear infinite" }}>
      {[...Array(2)].map((_, o) =>
        words.map((w, i) => (
          <span key={`${o}-${i}`}
            className="text-xs font-bold tracking-[.3em] uppercase mx-8"
            style={{ fontFamily: "'Syne',sans-serif", color: i % 4 === 0 ? accent : "rgba(255,255,255,.07)" }}>
            {w} ·
          </span>
        ))
      )}
    </div>
  </div>
);

// ─── Section header ───────────────────────────────────────────────────────────
const SectionHeader = ({ num, tag, title, subtitle, bgWord, accent = "#06CCBC", rgb = "6,204,188" }) => {
  const [ref, visible] = useReveal();
  return (
    <div ref={ref} className="relative mb-16 text-center overflow-hidden">
      {/* Ghost bg word */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
        style={{ zIndex: 0 }}>
        <span className="font-black leading-none"
          style={{
            fontFamily: "'Syne',sans-serif",
            fontSize: "clamp(5rem,16vw,13rem)",
            color: `rgba(${rgb},.07)`,
            letterSpacing: "-.03em",
            transition: "color 1s",
          }}>
          {bgWord}
        </span>
      </div>

      <div className="relative z-10 space-y-3"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(24px)",
          transition: "opacity .8s ease, transform .8s ease",
        }}>
        {/* num + tag pill */}
        <div className="flex items-center justify-center gap-3">
          <div className="h-px w-8" style={{ background: accent }} />
          <span className="text-xs font-black tracking-[.28em] uppercase"
            style={{ color: accent, fontFamily: "'Syne',sans-serif" }}>
            {tag}
          </span>
          <div className="h-px w-8" style={{ background: accent }} />
        </div>

        {/* Title */}
        <h2 className="font-black text-white leading-none"
          style={{
            fontSize: "clamp(2.2rem,6vw,5rem)",
            fontFamily: "'Playfair Display',serif",
            letterSpacing: "-.03em",
          }}>
          {title}
        </h2>

        {/* Subtitle */}
        {subtitle && (
          <p className="text-gray-500 text-sm tracking-wide" style={{ fontFamily: "'Syne',sans-serif" }}>
            {subtitle}
          </p>
        )}

        {/* Accent underline */}
        <div className="flex justify-center pt-1">
          <div className="h-px w-16 rounded-full"
            style={{ background: `linear-gradient(90deg,transparent,${accent},transparent)` }} />
        </div>
      </div>
    </div>
  );
};

// ─── Incubator card ───────────────────────────────────────────────────────────
const IncubatorCard = ({ incubator, delay = 0 }) => {
  const [ref, visible] = useReveal();
  const [hovered, setHovered] = useState(false);

  return (
    <div ref={ref}
      className="flex flex-col items-center gap-3 cursor-pointer group"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(28px)",
        transition: `opacity .7s ease ${delay}ms, transform .7s ease ${delay}ms`,
      }}>

      {/* Avatar ring */}
      <div className="relative">
        <div
          className="absolute inset-0 rounded-full transition-all duration-500"
          style={{
            boxShadow: hovered ? `0 0 28px rgba(6,204,188,.5), 0 0 0 2px #06CCBC` : "0 0 0 1px rgba(255,255,255,.12)",
            borderRadius: "9999px",
          }}
        />
        <div
          className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden transition-all duration-500"
          style={{
            backgroundImage: `url(${incubator.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transform: hovered ? "scale(1.08)" : "scale(1)",
            filter: hovered ? "brightness(1.1)" : "brightness(0.85) grayscale(0.2)",
          }}
        />
      </div>

      {/* Name */}
      <p className="text-sm font-bold text-center transition-colors duration-300 leading-tight"
        style={{
          fontFamily: "'Syne',sans-serif",
          color: hovered ? "#06CCBC" : "rgba(255,255,255,.75)",
          maxWidth: "90px",
        }}>
        {incubator.name}
      </p>
    </div>
  );
};

// ─── Person card ──────────────────────────────────────────────────────────────
const PersonCard = ({ person, delay = 0, accent = "#06CCBC", rgb = "6,204,188" }) => {
  const [ref, visible] = useReveal();
  const [hovered, setHovered] = useState(false);

  return (
    <div ref={ref}
      className="flex flex-col items-center gap-3 cursor-pointer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(28px)",
        transition: `opacity .7s ease ${delay}ms, transform .7s ease ${delay}ms`,
      }}>

      {/* Avatar with accent ring + glow */}
      <div className="relative">
        {/* Outer glow ring */}
        <div
          className="absolute -inset-1 rounded-full transition-all duration-500"
          style={{
            background: hovered ? `radial-gradient(circle, rgba(${rgb},.3), transparent)` : "transparent",
            borderRadius: "9999px",
          }}
        />
        {/* Border ring */}
        <div
          className="absolute inset-0 rounded-full transition-all duration-500"
          style={{
            boxShadow: hovered
              ? `0 0 32px rgba(${rgb},.5), 0 0 0 2px ${accent}`
              : `0 0 0 1px rgba(255,255,255,.12)`,
            borderRadius: "9999px",
          }}
        />
        <div
          className="w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden transition-all duration-500 relative z-10"
          style={{
            backgroundImage: `url(${person.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transform: hovered ? "scale(1.06)" : "scale(1)",
            filter: hovered ? "brightness(1.1)" : "brightness(0.85)",
          }}
        />

        {/* Accent dot bottom */}
        <div
          className="absolute bottom-0.5 right-0.5 z-20 w-3.5 h-3.5 rounded-full border-2 transition-all duration-300"
          style={{
            background: hovered ? accent : "rgba(255,255,255,.2)",
            borderColor: "rgba(0,0,0,.6)",
          }}
        />
      </div>

      {/* Name */}
      <div className="text-center space-y-0.5">
        <p className="font-black text-white text-sm leading-tight transition-colors duration-300"
          style={{
            fontFamily: "'Playfair Display',serif",
            color: hovered ? accent : "white",
          }}>
          {person.name}
        </p>
        <p className="text-xs leading-tight text-gray-500"
          style={{ fontFamily: "'Syne',sans-serif", maxWidth: "120px", margin: "0 auto" }}>
          {person.designation}
        </p>
      </div>
    </div>
  );
};

// ─── Main ─────────────────────────────────────────────────────────────────────
const Enablers = () => {
  const GT = {
    background: "linear-gradient(88.52deg,#1263AF 29%,#06CCBC 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  };

  return (
    <div className="relative min-h-screen text-white overflow-x-hidden"
      style={{ fontFamily: "'Syne',sans-serif" }}>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=Syne:wght@400;600;700;800&display=swap');
        @keyframes enMarquee { from{transform:translateX(0)} to{transform:translateX(-50%)} }
        @keyframes enFadeUp  { from{opacity:0;transform:translateY(30px)} to{opacity:1;transform:translateY(0)} }
        @keyframes enSpin    { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
        @keyframes enPulse   { 0%,100%{opacity:.5;transform:scale(1)} 50%{opacity:.9;transform:scale(1.04)} }
        .en-h1 { animation: enFadeUp .9s cubic-bezier(.22,1,.36,1) both .1s; opacity:0; }
        .en-h2 { animation: enFadeUp .9s cubic-bezier(.22,1,.36,1) both .25s; opacity:0; }
        .en-h3 { animation: enFadeUp .9s cubic-bezier(.22,1,.36,1) both .4s; opacity:0; }
        .en-h4 { animation: enFadeUp .9s cubic-bezier(.22,1,.36,1) both .55s; opacity:0; }
      `}</style>

      {/* ── Dot-grid atmosphere */}
      <div className="fixed inset-0 pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle, rgba(6,204,188,.06) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
          opacity: .5,
          zIndex: 0,
        }} />

      {/* ── Page Hero ─────────────────────────────────────────────── */}
      <section className="relative flex flex-col items-center justify-center text-center px-6 pt-24 pb-16 z-10">

        {/* Rotating rings */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 pointer-events-none">
          <div className="absolute inset-0 rounded-full"
            style={{ border: "1px solid rgba(6,204,188,.08)", animation: "enSpin 35s linear infinite" }} />
          <div className="absolute inset-8 rounded-full"
            style={{ border: "1px solid rgba(18,99,175,.06)", animation: "enSpin 25s linear infinite reverse" }} />
        </div>
        <h1 className="en-h2 font-black text-white leading-none mb-4"
          style={{ fontSize: "clamp(3rem,9vw,8rem)", fontFamily: "'Playfair Display',serif", letterSpacing: "-.04em" }}>
          Our <span style={GT}>People</span><br />& Partners
        </h1>
        <p className="en-h3 text-gray-400 max-w-lg mx-auto text-base md:text-lg leading-relaxed mb-10">
          The incubators, advisors, and team members who make X Boson AI's mission possible.
        </p>

        {/* Stats row */}
        <div className="en-h4 flex flex-wrap justify-center gap-3">
          {[
            ["7", "Incubators"],
            ["3", "Advisors"],
            ["7", "Team Members"],
          ].map(([n, l], i) => (
            <div key={i} className="flex items-baseline gap-2 px-5 py-2.5 rounded-full"
              style={{ border: "1px solid rgba(255,255,255,.08)" }}>
              <span className="text-xl font-black" style={GT}>{n}</span>
              <span className="text-xs text-gray-500">{l}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── Marquee 1 */}
      <Marquee words={["IN-Space","Maker Village","KAU RABI","KSUM","Digital University","NAARM","ICAR","Enablers","Partners","Supported By"]} />

      {/* ══════════════════════════════════════
          ENABLERS SECTION
          ══════════════════════════════════════ */}
      <section className="relative z-10 px-6 py-24 max-w-6xl mx-auto">

        <SectionHeader
          num="01"
          tag="Incubators & Partners"
          title="Enablers"
          subtitle="Organisations powering CAAX and KrishiSat"
          bgWord="BACKED"
          accent="#06CCBC"
          rgb="6,204,188"
        />

        {/* 6-col row */}
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-8 md:gap-10 justify-items-center mb-10">
          {incubators.slice(0, 6).map((inc, i) => (
            <IncubatorCard key={inc.id} incubator={inc} delay={i * 80} />
          ))}
        </div>

        {/* 7th centered */}
        {incubators.length > 6 && (
          <div className="flex justify-center">
            <IncubatorCard incubator={incubators[6]} delay={480} />
          </div>
        )}
      </section>

      {/* ── Marquee 2 */}
      <Marquee
        words={["Dr Anilakumar","Dr Snany Surendran","Dr Reshmi","Advisors","Expert Guidance","Scientific Advisory"]}
        accent="#C084FC"
      />

      {/* ══════════════════════════════════════
          ADVISORS SECTION
          ══════════════════════════════════════ */}
      <section className="relative z-10 px-6 py-24 max-w-5xl mx-auto">

        <SectionHeader
          num="02"
          tag="Scientific & Medical Advisory"
          title="Our Advisors"
          bgWord="EXPERTS"
          accent="#C084FC"
          rgb="192,132,252"
        />

        {/* Decorative accent lines */}
        <div className="flex items-center gap-4 mb-12">
          <div className="flex-1 h-px" style={{ background: "linear-gradient(90deg,transparent,rgba(192,132,252,.25))" }} />
          <div className="w-2 h-2 rounded-full" style={{ background: "#C084FC", boxShadow: "0 0 12px #C084FC" }} />
          <div className="flex-1 h-px" style={{ background: "linear-gradient(90deg,rgba(192,132,252,.25),transparent)" }} />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 md:gap-16 justify-items-center max-w-3xl mx-auto">
          {advisors.map((advisor, i) => (
            <PersonCard key={i} person={advisor} delay={i * 120} accent="#C084FC" rgb="192,132,252" />
          ))}
        </div>
      </section>

      {/* ── Marquee 3 */}
      <Marquee
        words={["CEO","CTO","CGO","COO","CAD","CCO","Manufacturing","Leadership","Team","X Boson AI"]}
        accent="#34D399"
      />

      {/* ══════════════════════════════════════
          TEAM SECTION
          ══════════════════════════════════════ */}
      <section className="relative z-10 px-6 py-24 max-w-6xl mx-auto">

        <SectionHeader
          num="03"
          tag="The Core Team"
          title="Meet Our Team"
          bgWord="TEAM"
          accent="#34D399"
          rgb="52,211,153"
        />

        {/* Decorative accent lines */}
        <div className="flex items-center gap-4 mb-12">
          <div className="flex-1 h-px" style={{ background: "linear-gradient(90deg,transparent,rgba(52,211,153,.25))" }} />
          <div className="w-2 h-2 rounded-full" style={{ background: "#34D399", boxShadow: "0 0 12px #34D399" }} />
          <div className="flex-1 h-px" style={{ background: "linear-gradient(90deg,rgba(52,211,153,.25),transparent)" }} />
        </div>

        {/* Row 1 — 4 members */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-10 md:gap-12 justify-items-center mb-12">
          {team.slice(0, 4).map((member, i) => (
            <PersonCard key={i} person={member} delay={i * 90} accent="#34D399" rgb="52,211,153" />
          ))}
        </div>

        {/* Row 2 — remaining members centered */}
        <div className="flex flex-wrap justify-center gap-10 md:gap-16">
          {team.slice(4).map((member, i) => (
            <PersonCard key={i + 4} person={member} delay={i * 90} accent="#34D399" rgb="52,211,153" />
          ))}
        </div>
      </section>

      {/* ── Bottom CTA strip */}
      <section className="relative z-10 px-6 pb-24 max-w-6xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl p-10 md:p-14 text-center"
          style={{ border: "1px solid rgba(255,255,255,.06)" }}>

          {/* Spinning rings */}
          <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full pointer-events-none"
            style={{ border: "1px solid rgba(6,204,188,.07)", animation: "enSpin 25s linear infinite" }} />
          <div className="absolute -bottom-10 -left-10 w-36 h-36 rounded-full pointer-events-none"
            style={{ border: "1px solid rgba(18,99,175,.07)", animation: "enSpin 18s linear infinite reverse" }} />

          <div className="relative z-10">
            <p className="text-xs font-black tracking-[.3em] uppercase mb-3" style={{ color: "#06CCBC" }}>
              Join the Mission
            </p>
            <h2 className="font-black text-white leading-none mb-5"
              style={{ fontSize: "clamp(1.8rem,4.5vw,3.5rem)", fontFamily: "'Playfair Display',serif", letterSpacing: "-.03em" }}>
              Building the future of<br />
              <span style={GT}>agriculture together.</span>
            </h2>
            <p className="text-gray-400 max-w-md mx-auto text-sm leading-relaxed">
              X Boson AI brings together world-class advisors, incubators, and a passionate team to transform how the world grows food.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Enablers;